import { Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import SectionChapter from '../../Tutorial/SectionChapter';
import SectionHeader from '../../Tutorial/SectionHeader';
import { FindMoreButton } from '../../Home/HomeFeatures/FindMoreButton';
import { tutorialLinks } from '../../../common/urlLinks';

const GroupsFeature = ({ refs }) => {
    const paste = [
        {
            children: (
                <>
                    <ul>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.groups.description.1" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.groups.description.2" />
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="h6">
                                <FormattedMessage id="page.home.feature.groups.description.3" />
                            </Typography>
                        </li>
                    </ul>
                    <a href={tutorialLinks.groups}>
                        <FindMoreButton />
                    </a>
                </>
            ),
        },
    ];
    return (
        <>
            <SectionHeader
                refs={refs}
                title={'page.home.feature.groups.tag'}
                id={'section-groups'}
                img={`/static/asset/img/features/grupuri.png`}
            />
            <SectionChapter
                refs={refs}
                id={'section-groups-section'}
                title={'page.home.feature.groups.description'}
                explanations={paste}
            />
        </>
    );
};

export default GroupsFeature;
